import { render } from "./EditItem3.vue?vue&type=template&id=b08406d4&scoped=true"
import script from "./EditItem3.vue?vue&type=script&lang=js"
export * from "./EditItem3.vue?vue&type=script&lang=js"

import "./EditItem3.vue?vue&type=style&index=0&id=b08406d4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08406d4"],['__file',"src/components/EditItem3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b08406d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b08406d4', __exports__)) {
    api.reload('b08406d4', __exports__)
  }
  
  module.hot.accept("./EditItem3.vue?vue&type=template&id=b08406d4&scoped=true", () => {
    api.rerender('b08406d4', render)
  })

}


export default __exports__